import { resolveElements as s } from "./atoms-v2972.js";
function a(t, n) {
  const o = s(t), e = new AbortController(), r = {
    passive: !0,
    ...n,
    signal: e.signal
  };
  return [o, r, () => e.abort()];
}
export {
  a as setupGesture
};
